<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Locais | Edição" />
    <v-row justify="center" align="center">
      <v-col>
        <v-card class="pa-8">
          <form-location v-model="model" @submit="($model: Local) => submit($model)" />
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script lang="ts" setup>
import { onBeforeMount, ref } from 'vue'
import TPageTitle from '@/components/TPageTitle.vue'
import FormLocation from './form-location.vue'
import Local from '@/types/Local'
import LocalService from '@/services/LocalService'
import { useLoader } from '@/stores/loader'
import { useSnackBar } from '@/stores/snackbar'
import { useRouter } from 'vue-router'
import { useProducerStore } from '@/stores/producer'

const loader = useLoader()
const snackbar = useSnackBar()
const router = useRouter()
const { producer } = useProducerStore()

const model = ref({
  name: '',
  active: true,
  address: '',
  number: '',
  complement: '',
  state: '',
  city: '',
  neighborhood: '',
  zip_code: '',
  producer_id: producer?.id,
} as Local)

async function submit(model: Local) {
  try {
    loader.increment()

    await (new LocalService()).update(model.id, model)

    snackbar.show(
      'Local criado com sucesso',
      'success',
    )

    router.push({ name: 'list-locations' })
  } finally {
    loader.decrement()
  }
}

async function fetch() {
  try {
    loader.increment()

    const response = await (new LocalService()).show(router.currentRoute.value.params.id as string)

    model.value = response.data.data
  } finally {
    loader.decrement()
  }
}

onBeforeMount(() => {
  fetch()
})

</script>
